import { useContext } from 'react';
import { UserContext } from '../../contexts/user-context';
import { useVenturesContext } from '../../contexts/ventures-context';
import ChangeStatusModal from '../common/change-status-modal';

function VentureArchiveModal() {
  const { hasAccessToAction } = useContext(UserContext);
  const {
    isChangingVentureStatus,
    archiveTargetVentures,
    changeVentureStatus,
    setArchiveTargetVentures,
  } = useVenturesContext();

  const length = archiveTargetVentures?.length || 0;

  return hasAccessToAction('venture.details.update') ? (
    <ChangeStatusModal
      open={!!archiveTargetVentures}
      title='Archive ventures'
      text={`Do you really want to archive ${length} ${
        length === 1 ? 'venture' : 'ventures'
      }?`}
      loading={isChangingVentureStatus}
      onClose={() => setArchiveTargetVentures(null)}
      onSubmit={() => changeVentureStatus('Archived')}
    />
  ) : null;
}

export default VentureArchiveModal;
